(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["drip-form"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Prefill the email field from an ?email= query param. Visitors arriving from
  // the footer newsletter redirect carry their address in the URL; drop it into
  // the Drip email input so they don't retype it. Works for inline and popup
  // forms (the value is set on the hidden input at load and shows on open).
  var params = new URLSearchParams(window.location.search);
  var email = (params.get('email') || '').trim();
  if (!email) return;

  var apply = function () {
    document.querySelectorAll('.drip-ef input[name="fields[email]"]').forEach(function (field) {
      if (field.value) return;
      field.value = email;
      field.dispatchEvent(new Event('input', { bubbles: true }));
      field.dispatchEvent(new Event('change', { bubbles: true }));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();
})();
